/**
 * Страница сброса пароля по токену из письма.
 * URL: /reset-password?token=...
 * Шаги:
 *   GET token из query → POST /api/auth/reset-password { token, password } → success.
 */
import { useState, type FormEvent } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";

import { api, ApiError } from "@/api/client";


export function ResetPasswordPage() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { token?: string };
  const token = search?.token || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Токен не найден в URL — откройте ссылку из письма заново");
      return;
    }
    if (password !== confirm) {
      setError("Пароли не совпадают");
      return;
    }
    if (password.length < 6) {
      setError("Пароль должен быть не короче 6 символов");
      return;
    }
    setSubmitting(true);
    try {
      await api("/api/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ token, password }),
      });
      setSuccess(true);
      setTimeout(() => void navigate({ to: "/login" }), 2000);
    } catch (e) {
      if (e instanceof ApiError) {
        if (e.status === 400) {
          setError("Токен недействителен или истёк. Запросите новую ссылку.");
        } else {
          setError(`Ошибка ${e.status}`);
        }
      } else {
        setError("Сеть недоступна");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-mark">К</div>
          <div>
            <div className="login-title">Кирпичные беседки</div>
            <div className="login-sub">Сброс пароля</div>
          </div>
        </div>

        {success ? (
          <div className="alert alert-green">
            <div className="alert-body">
              Пароль изменён. Перенаправление на страницу входа…
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="login-form">
            <div style={{ fontSize: 13, color: "var(--ink-3)", marginBottom: 8 }}>
              Введите новый пароль для своей учётной записи.
            </div>
            <label className="login-label">
              <span>Новый пароль (≥ 6 символов)</span>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} disabled={submitting} autoFocus/>
            </label>
            <label className="login-label">
              <span>Повторите пароль</span>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} disabled={submitting}/>
            </label>
            {error && <div className="alert alert-red"><div className="alert-body">{error}</div></div>}
            <button type="submit" className="btn btn-primary" disabled={submitting || !token}>
              {submitting ? "Сохранение…" : "Сохранить новый пароль"}
            </button>
          </form>
        )}

        <div style={{ marginTop: 16, fontSize: 12, textAlign: "center" }}>
          <a onClick={() => void navigate({ to: "/login" })} style={{ color: "var(--brick)", cursor: "pointer", textDecoration: "underline" }}>
            ← Назад к входу
          </a>
        </div>
      </div>
    </div>
  );
}
